exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".table thead {\n    border: 0!important;\n}\n\n.table tbody tr {\n    cursor: pointer;\n\n    background-color: #f6f6f6;\n}\n\n.table tbody tr:nth-child(2n) {\n    background-color: #fff;\n}\n\n.table tbody tr:hover {\n    background-color: #f6f6f6;\n}\n\n.table-fix-cell {\n    overflow: hidden;\n\n    max-height: 34px;\n}\n\n.table--cell {\n\t-webkit-box-sizing: border-box;\n\t        box-sizing: border-box;\n    vertical-align: top;\n    white-space: normal!important;\n}\n\n.table--cell-body {\n\tpadding-top: 10px;\n    font-size: 14px!important;\n    line-height: 18px;\n}\n\n.table--cell-th {\n    padding-top: 19px;\n    padding-left: 20px!important;\n\n    color: #000!important;\n\n    font-size: 16px!important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1}!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/ui/table.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/ui/table.css
// module chunks = 0